export default __webpack_public_path__ + "static/media/bitcoin-gold.d59e103e.png";